module.exports = __webpack_public_path__ + "img/avatar.8604c7ce.png";